export function validateLaotianPhoneNumber(phoneNumber) {
    // const regex = /^\+856\d{8}$/;
    const regex = /^\d{8}$/;
    return regex.test(phoneNumber);
};

export function validateMainLaotianPhoneNumber(phoneNumber) {
    if (!phoneNumber) return false; // Ensuring phone number is not empty

    const firstDigit = phoneNumber.charAt(0);
    const firstFiveDigits = phoneNumber.substring(0, 5);
    const firstSixDigits = phoneNumber.substring(0, 6);
    const firstSevenDigits = phoneNumber.substring(0, 7);

    const isInvalidPrefix = (prefix) => 
        prefix === "22222" || prefix === "222222" || prefix === "2222222" ||
        prefix === "99999" || prefix === "999999" || prefix === "9999999" ||
        prefix === "77777" || prefix === "777777" || prefix === "7777777" ||
        prefix === "55555" || prefix === "555555" || prefix === "5555555";

    if (isInvalidPrefix(firstFiveDigits) || isInvalidPrefix(firstSixDigits) || isInvalidPrefix(firstSevenDigits)) {
        return false;
    }

    switch (firstDigit) {
        case '2':
        case '9':
        case '7':
        case '5':
            return true;
        default:
            return false; // If the first digit is not valid
    }
}


export const validatePhone = (value) => {
    let error;
    if (!/^\d{8}$/.test(value)) {
        error = "Phone number must be exactly 8 digits.";
    }
    return error;
};